import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'

import { ORGANIZATION_ADMIN_WORKSPACE_ID } from '@flowx/designer/modules/workspaces/shared/commons.types'

import { WorkspacesAndPermissionsStore } from '../workspaces-and-permissions.store'

/**
 * Selects the organisation-admin workspace when it isn't already the active one. Idempotent, so
 * it is safe to call from every guard protecting a route under `/organisation-admin`.
 */
export function ensureOrganisationAdminWorkspaceSelected(
  workspacesAndPermissionsStore: InstanceType<typeof WorkspacesAndPermissionsStore>
): void {
  const selectedWorkspace = workspacesAndPermissionsStore.selectedWorkspace()
  if (selectedWorkspace?.id !== ORGANIZATION_ADMIN_WORKSPACE_ID) {
    workspacesAndPermissionsStore.changeSelectedWorkspaceId(ORGANIZATION_ADMIN_WORKSPACE_ID)
  }
}

export const setOrganisationAdminWorkspaceGuard: CanActivateFn = (): boolean => {
  // Set organisation admin as selected workspace before navigation
  ensureOrganisationAdminWorkspaceSelected(inject(WorkspacesAndPermissionsStore))
  return true
}
